import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DeliveryAddress } from '../models/delivery-address.model';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';
import { EANCode } from '../models/ean-code.model';

@Injectable()
export class DeliveryAddressService {
    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    get() {
        return this.http.get('api/DeliveryAddress', this.getAuthHeader(true));
    }

    getById(id: number) {
        return this.http.get('api/DeliveryAddress/' + id, this.getAuthHeader(true));
    }

    getDeliveryAddressById(id: number) {
        return this.http.get('api/DeliveryAddress/GetById/' + id, this.getAuthHeader(true));
    }

    getByCustomerId(customerId: number) {
        return this.http.get('api/DeliveryAddress/GetByCustomer/' + customerId, this.getAuthHeader(true));
    }

    getIsExistsEanCode(deliveryAddressId: number, eanCode: EANCode) {
        return this.http.get('api/DeliveryAddress/IsExistsEanCode/' + deliveryAddressId + '/' + eanCode, this.getAuthHeader(true));
    }

    createUpdate(deliveryAddress: DeliveryAddress) {
        return this.http.post('api/DeliveryAddress', deliveryAddress, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get('api/DeliveryAddress/Delete/' + id, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        const options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/delivery-address.service.ts